'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';
import { useDashboard } from '@/provider/dashboard-provider';
import { breadcrumbStore } from '@/store/breadcrumb.store';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './ui/breadcrumb';

function Separator() {
  return <BreadcrumbSeparator className="hidden md:block" />;
}

const translates: Record<string, string> = {
  orders: 'Pedidos',
  products: 'Productos',
  catalog: 'Catálogo',
  sales: 'Ventas',
  settings: 'Configuración',
  account: 'Cuenta',
  pos: 'Punto de venta',
  cashiers: 'Cajas',
  categories: 'Categorias',
  discounts: 'Códigos de descuento',
  new: 'Nuevo',
  subselection: 'Adicionales y Opcionales',
  printers: 'Impresoras',
  totems: 'Puntos de venta',
  displays: 'Llamadores',
  featured: 'Destacados',
  recommended: 'Recomendados',
  promos: 'Promociones',
  product: 'Productos',
  category: 'Categorías',
  additional: 'Adicionales',
  turns: 'Turnos',
  takeorder: 'Tomar Pedido',
};

// Me parece chistoso usar pan rallado en vez de breadcrumb porque así no rompe con el componente original jajaja
export function PanRallado() {
  const paths = usePathname();
  const pathNames = paths
    .split('/')
    .filter(path => path)
    .slice(1);
  const { locationId } = useDashboard();
  const templates = breadcrumbStore(state => state.templates);

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbPage>Inicio</BreadcrumbPage>
        </BreadcrumbItem>
        {pathNames.length > 0 && <Separator />}
        {pathNames.map((link, index) => {
          const href = `/${locationId}/${pathNames.slice(0, index + 1).join('/')}`;

          return (
            <React.Fragment key={`${link}-${href}`}>
              <BreadcrumbItem>
                {index === pathNames.length - 1 ? (
                  <BreadcrumbPage>{translates[link] ?? templates[index] ?? link}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link href={href}>{translates[link] ?? templates[index] ?? link}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {pathNames.length !== index + 1 && <Separator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
